import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { timeout, catchError } from 'rxjs/operators';
import { GenericService } from './generic.service';

/** Tempo máximo de espera (11 min): backend espera até 10 min 31 s do Lambda. */
const REQUEST_TIMEOUT_MS = 11 * 60 * 1000;

@Injectable({
  providedIn: 'root'
})
export class IntegracaoEnvioService extends GenericService {

  constructor(http: HttpClient) {
    super(http, 'integracao-envio');
  }

  /**
   * Envia dados de integração ANA para a estação.
   * Body: estacao_id, data_inicio, data_final (YYYY-MM-DD HH:mm:ss em horário de Brasília, como no filtro de dados de variável).
   */
  enviarDados(estacaoId: number, dataInicio: string, dataFinal?: string): Observable<any> {
    const body: Record<string, unknown> = {
      estacao_id: estacaoId,
      data_inicio: dataInicio,
      data_final: dataFinal ?? dataInicio.replace(' 00:00:00', ' 23:59:59').replace(/^(\d{4}-\d{2}-\d{2})$/, '$1 23:59:59')
    };

    return this.http.post(`${this.url_base}/${this.prefixo}/enviar`, body).pipe(
      timeout(REQUEST_TIMEOUT_MS),
      catchError(err => {
        if (err.name === 'TimeoutError') {
          return throwError({
            error: {
              message: 'O processamento demorou mais que o tempo esperado. Tente novamente ou agende uma nova execução.'
            }
          });
        }
        return throwError(err);
      })
    );
  }

}
